import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import createAbsoluteGrid from 'ks-absolute-grid';



import * as actions from '../../actions';
import * as selectors from '../../selectors';

import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import TabPanel from '../tab_panel/TabPanel';
import ChildrenPanel from '../children_panel/ChildrenPanel';
import TemplateLoader from '../common/TemplateLoader';


import '../../styles/style.css';


class MainTemplatePanel extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      tabGrid: null,
      childrenGrid: null
    };
    
    this.renderTabPanel = this.renderTabPanel.bind(this);
    this.renderChildrenPanel = this.renderChildrenPanel.bind(this);
    this.handleOnTabClick = this.handleOnTabClick.bind(this);
    this.handleOnChildClick = this.handleOnChildClick.bind(this);
  }
  
  
  _getTabGrid(displayComponent, displayProps) {
    const { tabGrid } = this.state;
    
    if (tabGrid) {
      return tabGrid;
    }

    const grid = createAbsoluteGrid(displayComponent, displayProps);
    
    this.setState({
      tabGrid: grid
    });

    return grid;
  }

  
  _getChildrenGrid(displayComponent, displayProps) {
    const { childrenGrid } = this.state;

    if (childrenGrid) {
      return childrenGrid;
    }

    const grid = createAbsoluteGrid(displayComponent, displayProps);

    this.setState({
      childrenGrid: grid
    });

    return grid;
  }


  handleOnTabClick(tab) {
    const { selectTab } = this.props;
    selectTab(tab);
  }


  handleOnChildClick(child) {
    const { selectChild } = this.props;
    selectChild(child);
  }


  renderTabPanel(displayComponent, defaultDisplayProps, defaultGridProps) {
    const displayProps = {
      ...defaultDisplayProps,
      onTabClick: this.handleOnTabClick
    };

    const TabGrid = this._getTabGrid(displayComponent, displayProps);

    return (
      <TabGrid 
        {...defaultGridProps}
      />
    );
  }


  renderChildrenPanel(displayComponent, defaultDisplayProps, defaultGridProps) {
    const displayProps = {
      ...defaultDisplayProps,
      onChildClick: this.handleOnChildClick
    };

    const ChildrenGrid = this._getChildrenGrid(displayComponent, displayProps);

    return (
      <ChildrenGrid 
        {...defaultGridProps}
      />
    );
  }


  render() {
    const { isFetching, isSubmitting, isError } = this.props;

    if (isFetching || isSubmitting) {
      return (
        <TemplateLoader />
      );
    }

    return (
      <div className="ui grid hotkey-template" style={{ marginTop: 0 }}>     
        <div className="one column row ht-paddingless">
          <div className="column">
            <div className="ui divider"></div>
          </div>
        </div>
        {!isError &&
          <div className="one column row ht-normal-padding">
            <div className="ui column grid ht-paddingless">
              <div className="one column row ht-paddingless-bottom">
                <div className="column">
                  <Breadcrumbs />
                </div>
              </div>
              <div className="one column row">
                <div className="column">
                  <TabPanel render={this.renderTabPanel} />
                </div>
              </div>
              <div className="one column row">
                <div className="column">
                  <ChildrenPanel render={this.renderChildrenPanel} />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { isFetching, isSubmitting, isError } = selectors.getStatusState(state);

  return {
    isFetching,
    isSubmitting,
    isError
  }
}


function mapDispatchToProps(dispatch) {
  const { selectTab, selectChild } = actions;

  return bindActionCreators({
    selectTab,
    selectChild
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(MainTemplatePanel);
